import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1129.4317,113 L1129.4317,1807.14754 L936.637705,1807.14754 L484.865027,1355.37487 L169.414754,1355.37487 C76.0107531,1355.37487 0,1279.36411 0,1185.96011 L0,1185.96011 L0,734.187433 C0,640.783431 76.0107531,564.772678 169.414754,564.772678 L169.414754,564.772678 L484.865027,564.772678 L936.637705,113 L1129.4317,113 Z M1016.48853,225.94317 L983.396178,225.94317 L564.715848,644.623499 L564.715848,1275.52404 L983.396178,1694.20437 L1016.48853,1694.20437 L1016.48853,225.94317 Z M1671.9768,361.057083 C1831.90433,521.097555 1920,733.769543 1920,960.107655 C1920,1186.33282 1831.90433,1399.00481 1671.9768,1559.04528 L1671.9768,1559.04528 L1592.12598,1479.19446 C1730.82019,1340.50025 1807.05683,1156.177 1807.05683,960.107655 C1807.05683,763.925369 1730.82019,579.602117 1592.12598,440.907904 L1592.12598,440.907904 Z M1432.86482,600.801549 C1528.52768,697.819732 1581.1592,825.445514 1581.1592,960.073772 C1581.1592,1094.70203 1528.52768,1222.32781 1432.86482,1319.34599 L1432.86482,1319.34599 L1352.33634,1240.05989 C1427.10471,1164.27502 1468.21603,1064.88503 1468.21603,960.073772 C1468.21603,855.262511 1427.10471,755.872521 1352.33634,680.087654 L1352.33634,680.087654 Z M451.772678,677.715848 L169.414754,677.715848 C138.355383,677.715848 112.94317,703.015118 112.94317,734.187433 L112.94317,734.187433 L112.94317,1185.96011 C112.94317,1217.13243 138.355383,1242.4317 169.414754,1242.4317 L169.414754,1242.4317 L451.772678,1242.4317 L451.772678,677.715848 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAudioLine = /*#__PURE__*/function (_Component) {
  _inherits(IconAudioLine, _Component);

  var _super = _createSuper(IconAudioLine);

  function IconAudioLine() {
    _classCallCheck(this, IconAudioLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconAudioLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAudio",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconAudioLine.displayName = "IconAudioLine";
  return IconAudioLine;
}(Component);

IconAudioLine.glyphName = 'audio';
IconAudioLine.variant = 'Line';
IconAudioLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAudioLine;
export { IconAudioLine };